import React, { useEffect, useState } from 'react';
import API, { CDN_ROOT } from '../../API';
import { Button, Header } from 'react-frontier';
import { OnboardingUser } from '../../Classes';
import { useUser } from '../../Hooks';

import OnboardingWelcome from './OnboardingWelcome';
import OnboardingInfo from './OnboardingInfo';
import OnboardingAddress from './OnboardingAddress';
import OnboardingDocuments from './OnboardingDocuments';
import OnboardingThanks from './OnboardingThanks';
import OnboardingBank from './OnboardingBank';

enum OnboardingStage{
	WELCOME = 1,
	INFO = 2,
	ADDRESS = 3,
	ID = 4,
	BANK = 5,
	THANKS = 99,
	LOADING = 100,
}

var Onboarding = ()=>{
	var { refresh } = useUser();
	var [user, setUser] = useState<OnboardingUser>(null);
	var [loadError, setLoadError] = useState<string>(null);
	var [stage, setStage] = useState<OnboardingStage>(null);
	
	var getUser = ()=>{
		setLoadError(null);
		API.getOnboardingUser().then(res=>{
			if(res.error) return setLoadError(res.message);
			setUser(res.data);
			setStage(res.data.onboarded===true ? OnboardingStage.THANKS : OnboardingStage.WELCOME);
		}).catch(err=>{
			return setLoadError('Hubo un error inesperado cargando la información (LCL-ONBUSRG-1)');
		})
	}

	var nextStage = ()=>{
		if(stage===OnboardingStage.WELCOME){
			setStage(OnboardingStage.INFO);
		}else if(stage===OnboardingStage.INFO){
			setStage(OnboardingStage.ADDRESS);
		}else if(stage===OnboardingStage.ADDRESS){
			setStage(OnboardingStage.ID);
		}else if(stage===OnboardingStage.ID){
			setStage(OnboardingStage.BANK);
		}else if(stage===OnboardingStage.BANK){
			setStage(OnboardingStage.THANKS);
		}else if(stage===OnboardingStage.THANKS){
			setStage(OnboardingStage.LOADING);
			refresh();
		}
	}

	useEffect(()=>{
		if(!user) getUser();
	}, []);
	
	return <div className='tp onboarding-container-screen'>
		<img src={`${CDN_ROOT}/logo/LogoRH_128.webp`} className='logo' />
		<div className="contents">
			{loadError ? (
				<div className="loading">
					<Header text={'Error'} subtext={loadError} iconName='face-frown-open' actions={(
						<Button text='Reintentar' size='tiny' style={{ width: 120, padding: 0 }} onClick={getUser} />
					)} />
				</div>
			) : (!user || stage===OnboardingStage.LOADING) ? (
				<div className="loading">
					<Header loading text={stage===OnboardingStage.LOADING ? 'Completando el formulario' : 'Cargando tu información'} />
				</div>
			) : (
				stage===OnboardingStage.WELCOME ? (
					<OnboardingWelcome user={user} setUser={setUser} onFinish={nextStage} />
				) : stage===OnboardingStage.INFO ? (
					<OnboardingInfo user={user} setUser={setUser} onFinish={nextStage} />
				) : stage===OnboardingStage.ADDRESS ? (
					<OnboardingAddress user={user} setUser={setUser} onFinish={nextStage} />
				) : stage===OnboardingStage.ID ? (
					<OnboardingDocuments user={user} setUser={setUser} onFinish={nextStage} />
				) : stage===OnboardingStage.BANK ? (
					<OnboardingBank user={user} setUser={setUser} onFinish={nextStage} />
				) : stage===OnboardingStage.THANKS ? (
					<OnboardingThanks user={user} setUser={setUser} onFinish={nextStage} />
				) : null
			)}
		</div>
		{(stage!==OnboardingStage.THANKS && stage!==OnboardingStage.LOADING) && (
			<div className="logout">
				<div className="label">
					En cualquier momento puedes cerrar el formulario. <br /> Tus respuestas serán guardadas. <br />
					¿Deseas hacer el formulario después?
				</div>
				<Button basic color='black' size='tiny' text='Cerrar sesión' onClick={API.logout} />
			</div>
		)}
	</div>
}

export default Onboarding;